// Module
var code = `<section class="page-body default-content">

  <h2>Utilities</h2>
  <p>
    SpyneJS includes utility classes for <strong>spacing</strong>, <strong>flexbox</strong>,
    <strong>grid layouts</strong>, and <strong>theme overrides</strong>.
    These helper classes give developers fine-grained control for quick adjustments without writing custom CSS.
  </p>

  <!-- Spacing -->
  <h3>Spacing</h3>
  <p>
    Use margin (<code>.m-*</code>, <code>.mt-*</code>, etc.) and padding
    (<code>.p-*</code>, <code>.px-*</code>, <code>.py-*</code>) utilities
    based on the spacing scale (0 → 64).
  </p>
  <div class="utility-examples">
    <div class="box m-4 p-4">Box with <code>.m-4 .p-4</code></div>
    <div class="box mt-8">Box with <code>.mt-8</code></div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;div class="m-4 p-4"&gt;Box with margin 4 and padding 4&lt;/div&gt;
&lt;div class="mt-8"&gt;Box with margin-top 8&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Flex -->
  <h3>Flex</h3>
  <p>
    Flexbox utilities make it easy to align and distribute content.
    Use <code>.flex</code>, <code>.flex-col</code>,
    <code>.justify-center</code>, <code>.items-center</code>, etc.
  </p>
  <div class="utility-examples flex gap-4 justify-center">
    <div class="box">A</div>
    <div class="box">B</div>
    <div class="box">C</div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;div class="flex gap-4 justify-center"&gt;
  &lt;div class="box"&gt;A&lt;/div&gt;
  &lt;div class="box"&gt;B&lt;/div&gt;
  &lt;div class="box"&gt;C&lt;/div&gt;
&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Grid -->
  <h3>Grid</h3>
  <p>
    Grid utilities allow for responsive layouts with column and row helpers.
    Use <code>.grid</code>, <code>.grid-cols-*</code>, <code>.gap-*</code>, etc.
  </p>
  <div class="utility-examples grid grid-cols-3 gap-4">
    <div class="box">1</div>
    <div class="box">2</div>
    <div class="box">3</div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;div class="grid grid-cols-3 gap-4"&gt;
  &lt;div class="box"&gt;1&lt;/div&gt;
  &lt;div class="box"&gt;2&lt;/div&gt;
  &lt;div class="box"&gt;3&lt;/div&gt;
&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Theme Utils -->
  <h3>Theme Utils</h3>
  <p>
    Theme utilities expose CSS custom properties like
    <code>--text-primary</code>, <code>--bg</code>,
    <code>--brand</code>, and more.
    These can be used directly in inline styles or extended in custom CSS.
  </p>
  <div class="utility-examples">
    <p style="color: var(--brand);">This text uses <code>--brand</code></p>
    <p style="background-color: var(--bg); color: var(--text-primary);">
      This box uses background and text tokens
    </p>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;p style="color: var(--brand);"&gt;This text uses --brand&lt;/p&gt;
&lt;p style="background-color: var(--bg); color: var(--text-primary);"&gt;
  This box uses background and text tokens
&lt;/p&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Spacing, flex, and grid utilities follow the responsive scale and can be combined for adaptive layouts.</li>
    <li>Theme utilities ensure color and typography stay consistent across plugins and apps.</li>
    <li>Prefer utilities for layout tweaks, and semantic HTML + components for structured content.</li>
  </ul>

</section>
`;
// Exports
module.exports = code;